export enum InventoryControlUnitEnum {
  PRODUCT_CODE_UNIT = '1',
  JAN_CODE_UNIT = '2',
}

export const InventoryControlUnit = [
  { label: '商品コード単位', value: InventoryControlUnitEnum.PRODUCT_CODE_UNIT },
  { label: 'JANコード単位', value: InventoryControlUnitEnum.JAN_CODE_UNIT },
];
